import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {"display":"none","margin-left":"9999px"} }

import { ref, reactive, computed } from 'vue';
import Taro, { showLoading, showToast } from '@tarojs/taro';
import universalCell from '@/components/universal-cell/index.vue';
import videoUploader from '@/components/VideoUploader/index.vue';
import upload from '@/components/upload/index.vue';
import videoPlayer from '@/pages/index/components/select-media-list/videoPlayer.vue';
import { electronicDeleteFile } from '@/service/uploading';

interface Props {
  labelWidth?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'attachment',
  props: /*@__PURE__*/_mergeModels({
    labelWidth: { default: () => '80px' }
  }, {
    "files": {
  default: () => [],
},
    "filesModifiers": {},
  }),
  emits: ["update:files"],
  setup(__props: any) {

let videoUploaderRef = ref<InstanceType<typeof videoUploader> | null>(null);
let videoPlayerRef = ref<InstanceType<typeof videoPlayer> | null>(null);
let uploadRef = ref<
  | (InstanceType<typeof upload> & {
      uploaderRef?: { chooseImage: () => void };
    })
  | null
>(null);

const props = __props;

let initNo = ref<number>(0);
let showPreview = ref<boolean>(false);
let uploadFiles = _useModel<
  { _type: string; accessUrl: string; fileType: string; url: string }[]
>(__props, 'files');
let mediaTypeVisible = ref<boolean>(false);
let themeVars = reactive({
  'actionsheet-item-font-size': '18px',
  'font-size-base': '18px',
});
let menuMedia = reactive([
  { id: '1', name: '视频' },
  { id: '2', name: '照片' },
  { id: '3', name: '取消' },
]);

// 选择媒体上传类型
const mediaChoose = (item: { id: string; name: string }) => {
  console.log('选择媒体上传类型', item);
  if (item.id === '1') {
    videoUploaderRef.value?.handleClick();
  }
  if (item.id === '2') {
    console.log('uploadRef.value', uploadRef.value?.uploaderRef?.chooseImage());
  }
};

// 视频上传成功
const videoSuccess = data => {
  uploadFiles.value.push({ ...data[0], _type: 'video' });
};
// 播放视频
const openvideoPlayer = (
  item: { url: string; blobUrl: string },
  index: string | number
) => {
  item.blobUrl = '';
  console.log('item', item);
  videoPlayerRef.value?.open(item, index);
};
// 图片上传成功
const imageSuccess = data => {
  console.log('图片上传成功', data);
  uploadFiles.value.push({ ...data[0], _type: 'image' });
};
// 删除媒体
const deleteMedia = async (item, index: number) => {
  if (item?.eleId) {
    showLoading({ title: '删除中...' });
    await electronicDeleteFile(item.eleId);
  }
  uploadFiles.value.splice(index, 1);
  showToast({ title: '删除成功' });
};
// 图片预览
const showPreviewData = computed(() => {
  const imageExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'svg',
    'ico',
    'tiff',
    'psd',
  ];

  let result = uploadFiles.value?.map(item => {
    if (
      (item?._type as string) == 'image' ||
      imageExtensions.includes((item.fileType as string)?.toLowerCase())
    ) {
      return { src: item.accessUrl || item.url };
    }
  });
  return result.filter(item => item);
});

// 视频
const getAttachmentTypeIsVideo = (row: {
  _type: string;
  fileType: string;
}): boolean => {
  const videoExtensions = [
    'mp4',
    'webm',
    'ogg',
    'mov',
    'mkv',
    'avi',
    'flv',
    'wmv',
    'mpg',
    'mpeg',
    '3gp',
  ];
  return (
    row._type === 'video' ||
    videoExtensions.includes(row.fileType?.toLowerCase())
  );
};

// 图片
const getAttachmentTypeIsImages = (row: {
  _type: string;
  fileType: string;
}): boolean => {
  const imageExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'svg',
    'ico',
    'tiff',
    'psd',
  ];
  return (
    row._type === 'image' ||
    imageExtensions.includes(row.fileType?.toLowerCase())
  );
};

return (_ctx: any,_cache: any) => {
  const _component_taro_image = _resolveComponent("taro-image")!
  const _component_nut_action_sheet = _resolveComponent("nut-action-sheet")!
  const _component_nut_config_provider = _resolveComponent("nut-config-provider")!
  const _component_nut_image_preview = _resolveComponent("nut-image-preview")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(universalCell, {
      label: "附件",
      labelWidth: _ctx.labelWidth,
      borderType: "none",
      class: "remark",
      padding: "0"
    }, {
      text: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadFiles), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "relative w-150 h-150 m-[10px]"
            }, [
              (getAttachmentTypeIsVideo(item))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "w-full h-full bg-[#f7f8fa] flex-x-y-center bg-[rgba(0,0,0,.5)] overflow-hidden rounded-[20px]",
                    onClick: ($event: any) => (openvideoPlayer(item, index))
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("span", { class: "LY-bofang iconfont text-size-80 color-[#fff]" }, null, -1)
                  ]), 8, _hoisted_2))
                : _createCommentVNode("", true),
              (getAttachmentTypeIsImages(item, index))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: ($event: any) => ((_isRef(showPreview) //@ts-ignore
 ? showPreview.value = true : showPreview = true), (_isRef(initNo) //@ts-ignore
 ? initNo.value = index : initNo = index)),
                    class: "w-full h-full bg-[rgba(0,0,0,.5)] rounded-[20px]"
                  }, [
                    _createVNode(_component_taro_image, {
                      src: item.accessUrl || item.url,
                      mode: "aspectFit",
                      class: "w-full h-full flex-x-y-center"
                    }, null, 8, ["src"])
                  ], 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["labelWidth"]),
    _createVNode(_component_nut_config_provider, { "theme-vars": _unref(themeVars) }, {
      default: _withCtx(() => [
        _createVNode(_component_nut_action_sheet, {
          title: "选择上传类型",
          visible: _unref(mediaTypeVisible),
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(mediaTypeVisible) ? (mediaTypeVisible).value = $event : mediaTypeVisible = $event)),
          "menu-items": _unref(menuMedia),
          onChoose: mediaChoose
        }, null, 8, ["visible", "menu-items"])
      ]),
      _: 1
    }, 8, ["theme-vars"]),
    _createVNode(videoUploader, {
      ref_key: "videoUploaderRef",
      ref: videoUploaderRef,
      onSuccess: videoSuccess
    }, null, 512),
    _createVNode(videoPlayer, {
      ref_key: "videoPlayerRef",
      ref: videoPlayerRef
    }, null, 512),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(upload, {
        ref_key: "uploadRef",
        ref: uploadRef,
        onSuccess: imageSuccess
      }, null, 512)
    ]),
    _createVNode(_component_nut_image_preview, {
      show: _unref(showPreview),
      "init-no": _unref(initNo),
      images: showPreviewData.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_isRef(showPreview) //@ts-ignore
 ? showPreview.value = false : showPreview = false))
    }, null, 8, ["show", "init-no", "images"])
  ]))
}
}

})